import DefaultUserIcon from "@/common/images/icons/profileIcon.svg";
import { Link } from "react-router-dom";
import { nFormatter } from "@/common/utils/parseNumber";
import { routes } from "@/common/utils/routes";
import "./NicheCard.scss";

interface INicheCard {
  nicheName: string;
  followers: number;
  nicheImageUrl: string | null;
  id: string;
  highlightText?: React.ReactElement;
  onClick: () => void;
}

export const NicheCard = ({
  nicheName,
  followers,
  nicheImageUrl,
  id,
  highlightText,
  onClick
}: INicheCard) => {
  return (
    <Link to={routes.niche(id)} onClick={onClick} aria-label={`Link to ${nicheName} niche`} className="nicheCard">
      <div className="nicheCardImageWrap">
        <img className="nicheImage" src={nicheImageUrl ?? DefaultUserIcon} alt={`Avatar for ${nicheName} niche`} />
      </div>
      <div className="nicheCardInfo">
        <span className="nicheName">{highlightText ?? nicheName}</span>
        <span className="nicheFollowers">{nFormatter(followers)} members</span>
      </div>
    </Link>
  );
};
